module.exports = __webpack_public_path__ + "img/pGcash.f0ab5fb2.png";